import { toast } from '@/components/ui/toaster.jsx';

// THE PRE-SUBMIT REFUSAL ON SCREEN (utils/carrier-presubmit presubmitRefusal):
// nothing was sent, one persistent row per blocker naming the pilot, each with
// the door that fixes it. true when the response was a refusal (the caller
// stops), false otherwise.
export function showPresubmitRefusal(res, carrierName, navigate) {
  if (!res?.blocked) return false;
  const items = Array.isArray(res.blocker_items) ? res.blocker_items : [];
  if (!items.length) {
    toast.error(`${carrierName} not sent: ${(res.blockers || []).join(' ')}`, { duration: 15000 });
    return true;
  }
  for (const b of items) {
    toast.error(`${carrierName} not sent: ${b.message}`, {
      duration: Infinity,
      // A selection (pilot_experience_unmatched) rides as router state to its door.
      ...(b.remedy_link && navigate ? { action: { label: b.selection ? (b.selection.kind === 'disagree' ? 'Pick his number' : 'Name the models') : 'Fix it', onClick: () => navigate(b.remedy_link, b.selection ? { state: { experienceSelection: b.selection } } : undefined) } } : {}),
    });
  }
  return true;
}
